/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AwsEbsVolumeRestoreResult {
  /**
  * ID of the restored EBS volume.
  */
  'volumeId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volumeId",
      "baseName": "volumeId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEbsVolumeRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

